import { useEffect, useState } from "react";
import { StatsContext } from ".";
import { Stats } from "@/pages/Index/StatsSection";
import { ErrorBoundary2 } from "@/pages/ErrorBoundary2";
import { supabase } from "@/lib/supabase/client";
import { useUserContext } from "../user";

const checkinInterval = 60000;
type StatsProviderProps = { children: React.ReactNode };
export function StatsProvider({ children }: StatsProviderProps) {
    const [stats, setStats] = useState<Stats>({
        completedSectionCount: 0,
        averageCheckinScore: NaN,
        dailyStreak: 1,
    });
    const { authReady, user } = useUserContext();

    useEffect(() => {
        if (!authReady || !user) return;

        const checkin = async () => {
            const { data, error } = await supabase.rpc("checkin");
            if (error) {
                // Since this isn't vital, fail silently for now
                return;
            }

            setStats(prev => {
                if (!data || prev.dailyStreak === data["dailyStreak"]) return prev;

                return {
                    ...prev,
                    dailyStreak: data["dailyStreak"],
                };
            });
        };

        checkin();
        const interval = setInterval(checkin, checkinInterval);
        return () => clearInterval(interval);
    }, [authReady, user]);

    return (
        <StatsContext.Provider value={{ stats, setStats }}>
            <ErrorBoundary2 msg="StatsContext Inner">
                {children}
            </ErrorBoundary2>
        </StatsContext.Provider>
    );
}